// ===== Production Constants =====

export const CALL_STATES = {
  IDLE: 'idle',
  CALLING: 'calling',
  RINGING: 'ringing',
  CONNECTING: 'connecting',
  CONNECTED: 'connected',
  RECONNECTING: 'reconnecting',
  DISCONNECTED: 'disconnected',
  ENDED: 'ended',
  FAILED: 'failed',
  REJECTED: 'rejected'
};

export const MESSAGE_TYPES = {
  TEXT: 'text',
  IMAGE: 'image',
  FILE: 'file',
  AUDIO: 'audio',
  VIDEO: 'video',
  SYSTEM: 'system'
};

export const ERROR_TYPES = {
  NETWORK: 'network',
  PERMISSION: 'permission',
  MEDIA: 'media',
  WEBRTC: 'webrtc',
  SOCKET: 'socket',
  VALIDATION: 'validation',
  SECURITY: 'security'
};

export const CONNECTION_STATES = {
  DISCONNECTED: 'disconnected',
  CONNECTING: 'connecting',
  CONNECTED: 'connected',
  RECONNECTING: 'reconnecting',
  FAILED: 'failed'
};

export const MEDIA_STATES = {
  INACTIVE: 'inactive',
  REQUESTING: 'requesting',
  ACTIVE: 'active',
  DENIED: 'denied',
  FAILED: 'failed'
};

export const SOCKET_EVENTS = {
  // Connection events
  CONNECT: 'connect',
  DISCONNECT: 'disconnect',
  CONNECT_ERROR: 'connect_error',
  RECONNECT: 'reconnect',
  RECONNECT_ERROR: 'reconnect_error',
  
  // User events
  JOIN_ROOM: 'join-room',
  LEAVE_ROOM: 'leave-room',
  USER_CONNECT: 'user-connect',
  USER_DISCONNECT: 'user-disconnect',
  USER_ONLINE: 'user-online',
  USER_OFFLINE: 'user-offline',
  CHECK_USER_STATUS: 'check-user-status',
  USER_STATUS_RESPONSE: 'user-status-response',
  
  // Message events
  SEND_MESSAGE: 'send-message',
  SEND_DIRECT_MESSAGE: 'send-direct-message',
  RECEIVE_MESSAGE: 'receive-message',
  RECEIVE_DIRECT_MESSAGE: 'receive-direct-message',
  MESSAGE_HISTORY: 'message-history',
  GET_MESSAGE_HISTORY: 'get-message-history',
  
  // WebRTC events
  WEBRTC_CALL_OFFER: 'webrtc-call-offer',
  WEBRTC_CALL_ANSWER: 'webrtc-call-answer',
  WEBRTC_ICE_CANDIDATE: 'webrtc-ice-candidate',
  WEBRTC_CALL_ENDED: 'webrtc-call-ended',
  WEBRTC_CALL_FAILED: 'webrtc-call-failed',
  WEBRTC_CALL_REJECTED: 'webrtc-call-rejected'
};

export const WEBRTC_EVENTS = {
  ICE_CANDIDATE: 'icecandidate',
  ICE_CONNECTION_STATE_CHANGE: 'iceconnectionstatechange',
  ICE_GATHERING_STATE_CHANGE: 'icegatheringstatechange',
  CONNECTION_STATE_CHANGE: 'connectionstatechange',
  SIGNALING_STATE_CHANGE: 'signalingstatechange',
  TRACK: 'track',
  DATA_CHANNEL: 'datachannel'
};

export const ICE_CONNECTION_STATES = {
  NEW: 'new',
  CHECKING: 'checking',
  CONNECTED: 'connected',
  COMPLETED: 'completed',
  FAILED: 'failed',
  DISCONNECTED: 'disconnected',
  CLOSED: 'closed'
};

export const DATA_CHANNEL_STATES = {
  CONNECTING: 'connecting',
  OPEN: 'open',
  CLOSING: 'closing',
  CLOSED: 'closed'
};

export const NOTIFICATION_TYPES = {
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error'
};

export const USER_ROLES = {
  PATIENT: 'patient',
  DOCTOR: 'doctor',
  ADMIN: 'admin'
};

export const CALL_DIRECTIONS = {
  INCOMING: 'incoming',
  OUTGOING: 'outgoing'
};

export const CALL_TYPES = {
  AUDIO: 'audio',
  VIDEO: 'video'
};

export const VALIDATION_PATTERNS = {
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  PHONE: /^\+?[\d\s\-\(\)]+$/,
  URL: /^https?:\/\/.+/,
  SOCKET_ID: /^[a-zA-Z0-9_-]+$/
};

export const SECURITY_RULES = {
  MAX_MESSAGE_LENGTH: 1000,
  MAX_FILE_SIZE: 10 * 1024 * 1024, // 10MB
  ALLOWED_IMAGE_TYPES: ['image/jpeg', 'image/png', 'image/gif', 'image/webp'],
  ALLOWED_FILE_TYPES: ['application/pdf', 'text/plain', 'application/msword', 'audio/wav', 'audio/webm', 'audio/mp3', 'audio/ogg'],
  BLOCKED_EXTENSIONS: ['.exe', '.bat', '.cmd', '.scr', '.vbs', '.js'],
  XSS_PATTERNS: [
    /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,
    /javascript:/gi,
    /on\w+\s*=/gi
  ]
};

export const PERFORMANCE_THRESHOLDS = {
  MESSAGE_RENDER_TIME: 16, // milliseconds (60fps)
  CALL_SETUP_TIME: 5000, // 5 seconds
  CONNECTION_TIMEOUT: 10000, // 10 seconds
  MEMORY_WARNING: 50 * 1024 * 1024, // 50MB
  CPU_WARNING: 80 // percentage
};

export const LOG_LEVELS = {
  ERROR: 0,
  WARN: 1,
  INFO: 2,
  DEBUG: 3,
  TRACE: 4
};

export const STORAGE_KEYS = {
  CHAT_SETTINGS: 'chat_settings',
  CALL_HISTORY: 'call_history',
  USER_PREFERENCES: 'user_preferences',
  DEBUG_LOGS: 'debug_logs'
};

export default {
  CALL_STATES,
  MESSAGE_TYPES,
  ERROR_TYPES,
  CONNECTION_STATES,
  MEDIA_STATES,
  SOCKET_EVENTS,
  WEBRTC_EVENTS,
  ICE_CONNECTION_STATES,
  DATA_CHANNEL_STATES,
  NOTIFICATION_TYPES,
  USER_ROLES,
  CALL_DIRECTIONS,
  CALL_TYPES,
  VALIDATION_PATTERNS,
  SECURITY_RULES,
  PERFORMANCE_THRESHOLDS,
  LOG_LEVELS,
  STORAGE_KEYS
};
